import React from "react"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import ReactHtmlParser from "react-html-parser"
import useWindowWidth from "../../hooks/useWindowWidth"

export default function UniverseLandingPageHeroComponent({
  heroImage,
  heroImageAltText,
  opacity,
  fontColor,
  infoHead,
  heading,
  subtext,
  enableExpandHero,
  mobileHeroImage,
  mobileHeroImageAltText,
}) {
  const headingHtml = ReactHtmlParser(heading)
  const fontColorSelected = SelectionFactoryHelper.getFromSelectionFactory(fontColor)
  //opacity settings are based on the font color style selected in the CMS.
  //opacityFilterSettings is passed as a scss variable to the stylesheet.
  const opacityFilterSettings = fontColorSelected == "cph-white" ? `rgba(7, 17, 67, ${opacity})` : `rgba(255, 255, 255, ${opacity})`

  const windowWidth = useWindowWidth()
  const isMobile = windowWidth <= 768
  const heroImageSrc = isMobile && enableExpandHero && mobileHeroImage ? mobileHeroImage : heroImage
  const heroImageAlt = isMobile && enableExpandHero && mobileHeroImageAltText ? mobileHeroImageAltText : heroImageAltText

  return (
    <div className={`universe-landing-page-hero-container${enableExpandHero ? " expand-hero" : ""}`}>
      <div className="image-container" style={{ "--opacitysettings": opacityFilterSettings }}>
        <img src={heroImageSrc} alt={heroImageAlt || ""} aria-hidden={heroImageAlt ? "false" : "true"} />
        <div className={`content ${fontColorSelected}`}>
          <p className="infohead-inverted">{infoHead}</p>
          <div className="universe-hero-heading">{headingHtml}</div>
          <p className="universe-hero-subtext">{subtext}</p>
        </div>
      </div>
    </div>
  )
}
